module.exports = __webpack_public_path__ + "static/media/regi_default.ef2dde97.svg";